import { render, staticRenderFns } from "./PasswordPair.vue?vue&type=template&id=37dcf663&"
import script from "./PasswordPair.vue?vue&type=script&lang=js&"
export * from "./PasswordPair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports